import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dateTime } from "../../Features/dateTime";
import { FiBell, FiInbox, FiCircle } from "react-icons/fi";
import PaginationBar from "../PaginationBar";
import NotificationImageModal from "./NotificationImageModal";
import customloader from "../../assets/images/RollingLoader.gif";
import useNotificationAction from "../../Hooks/useNotificationAction";
import "./Notifications.css";

const AllNotifications = () => {
  const notificationsCount = useSelector((state) => state.notification.notificationsCount);
  const { user } = useSelector((state) => state.auth);
  const [noOfPages, setNoOfPages] = useState(1);
  const [sizeOfPages, setSizeOfPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [count, setCount] = useState(0);
  const { handleNotificationStatus, imageModal, data, closeImageModal } = useNotificationAction();
  const userId = user.user_id;
  const changePage = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    const getNotifications = async () => {
      try {
        setIsLoading(true);
        setNotifications([]);
        const responseData = await axios.get(process.env.REACT_APP_API_URL + `/notifications/?user_id=${userId}&limit=${sizeOfPages}&offset=${currentPage * sizeOfPages - sizeOfPages}`, { withCredentials: true });
        if (responseData) {
          setIsLoading(false);
          setNotifications(responseData?.data?.data?.data);
          setNoOfPages(responseData?.data?.data?.pagination?.totalPages);
          setCount(responseData?.data?.data?.pagination?.count);
        }
      } catch (error) {
        setIsLoading(false);
        setNotifications([]);
      }
    };
    getNotifications();
  }, [currentPage, noOfPages, sizeOfPages, userId, notificationsCount]);
  const datetimeFunction = (value) => {
    const dateFormat = dateTime(value);
    return dateFormat.toLocaleDateString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  };
  const handleNotificationClick = async (item) => {
    await handleNotificationStatus(item);
  };
  return (
    <>
      {isLoading ? (
        <div className="notif-loading">
          <img src={customloader} alt="loader" width="60" height="60" />
        </div>
      ) : notifications.length === 0 ? (
        <div className="notif-empty">
          <div className="notif-empty-icon">
            <FiInbox />
          </div>
          <p className="notif-empty-title">No notifications found</p>
          <p className="notif-empty-subtitle">Notifications will appear here when they arrive</p>
        </div>
      ) : (
        <>
          {notifications.map((item, index) => (
            <div
              key={`all-notif-${item.id || index}`}
              className={`notif-card ${item.is_read === 0 ? "notif-card-unread" : ""}`}
              onClick={() => handleNotificationClick(item)}
            >
              <div className={`notif-card-icon ${item.is_read === 0 ? "notif-card-icon-unread" : "notif-card-icon-read"}`}>
                <FiBell />
              </div>
              <div className="notif-card-body">
                <p className="notif-card-title">{item?.title}</p>
                <p className="notif-card-text">{item?.body}</p>
                <p className="notif-card-time">{datetimeFunction(item.created_at)}</p>
              </div>
              {item?.is_read === 0 && <FiCircle className="notif-card-dot" size={8} fill="#8834ff" />}
            </div>
          ))}
          <div className="notif-pagination-row">
            <span className="notif-pagination-count">{count} results</span>
            <PaginationBar currentPage={currentPage} noOfPages={noOfPages} changePage={changePage} />
          </div>
        </>
      )}
      <NotificationImageModal
        show={imageModal}
        close={closeImageModal}
        data={data}
      />
    </>
  );
};

export default AllNotifications;
